// Info Dropdown toggle — extracted from main-product.js so sections other
// than main-product/main-account (e.g. account-downloads) can load just this.
// Guarded by window.dropdownsInitialized in case main-product.js is also
// present on the same page, so the click handler never double-binds.
document.addEventListener('DOMContentLoaded', function () {
  if (window.dropdownsInitialized) return;
  window.dropdownsInitialized = true;

  // Open first two dropdowns by default
  document.querySelectorAll('.js-info-dropdown').forEach(function (dropdown, index) {
    if (index < 1) {
      const header = dropdown.querySelector('.info-dropdown__header');
      const content = dropdown.querySelector('.info-dropdown__content');

      if (header && content) {
        header.setAttribute('aria-expanded', 'true');
        content.removeAttribute('hidden');
      }
    }
  });

  document.body.addEventListener('click', function (e) {
    const header = e.target.closest('.info-dropdown__header');
    if (!header) return;

    const dropdown = header.closest('.js-info-dropdown');
    if (!dropdown) return;

    const content = dropdown.querySelector('.info-dropdown__content');
    if (!content) return;

    e.stopPropagation();
    e.preventDefault();

    document.querySelectorAll('.js-info-dropdown').forEach(function (otherDropdown) {
      if (otherDropdown !== dropdown) {
        otherDropdown.querySelector('.info-dropdown__content').setAttribute('hidden', '');
        otherDropdown.querySelector('.info-dropdown__header').setAttribute('aria-expanded', 'false');
      }
    });

    const isExpanded = header.getAttribute('aria-expanded') === 'true';
    header.setAttribute('aria-expanded', !isExpanded);

    if (isExpanded) {
      content.setAttribute('hidden', '');
    } else {
      content.removeAttribute('hidden');
    }
  });
});
